import "../../App.css";
import QuotationForm from "../QuotationForm";

function QuotationPage({ sessionObject }) {
  if (!sessionObject.sessionVariables["modules"].includes("quotation-form")) {
    return;
  }
  return (
    <div className="page-mr">
      <QuotationForm sessionObject={sessionObject} />
    </div>
  );
}

export default QuotationPage;
